import React, { useState } from "react";
import axios from "axios";
import { URL } from "../../../../../../link";
import VideoPlayer from "../../../../../../utils/VideoPlayer";
import style from "../ModalMetrica.module.css";

const VerificarMetrica = ({
  filterMetricas,
  metricaV,
  editBool,
  setEditBool,
  user,
}) => {
  const [califico, setCalifico] = useState(0);
  const [valor, setValor] = useState("");
  const [error, setError] = useState("");
  let localUser = JSON.parse(localStorage.getItem("dataUser"));

  const handlerValor = (event) => {
    setValor(event.target.value);
  };

  const enviar = async (id) => {
    const data = { id, valor, validadorId: localUser.id, comentario: "" };
    if (califico === 0) {
      try {
        await axios.put(`${URL}/metrica/verificar`, data);
        setEditBool(true);
        setCalifico(1);
      } catch (error) {
        setError(error?.response?.data?.message || "Error al enviar la verificación de métrica");
      }
    }
  };

  return (
    <div className={style.contEdit}>
      {!editBool && (
        <div className={style.contBtnG}>
          <div className={style.contTitCerrar}>
            <h2 className={style.titEdit}>VERIFICAR MÉTRICA</h2>
            <span className={style.txtCerrar} onClick={() => setEditBool(true)}>
              Cancelar
            </span>
            {valor !== "" && (
              <p
                className={style.txtEnviar}
                onClick={() => enviar(filterMetricas(user, metricaV)[0].id)}
              >
                Enviar
              </p>
            )}
          </div>
          <p className={style.avisoG}>
            ¿Consideras que el video valida la métrica?
          </p>

          <div className={style.contEditBtn}>
            <div className={style.contOption}>
              <input
                type="radio"
                className={style.checkboxP}
                id="Si"
                value="Si"
                checked={valor === "Si"}
                onChange={handlerValor}
              />
              <p className={style.txtSi}>Sí</p>
              <input
                type="radio"
                className={style.checkboxP}
                id="No"
                value="No"
                checked={valor === "No"}
                onChange={handlerValor}
              />
              <p className={style.txtNo}>No</p>
            </div>
          </div>

          {error && <p className={style.error}>{error}</p>}

          {/* Reproducción del video asociado a la métrica */}
          {filterMetricas(user, metricaV)[0]?.video ? <div className={style.contVideo}>
            <VideoPlayer
              video={filterMetricas(user, metricaV)[0].video}
              controls
            />
          </div> : <p className={style.txtNoVideo}>No hay video asociado a esta métrica</p>}
        </div>
      )}
    </div>
  );
};

export default VerificarMetrica;
